export const environment = {
  production: false,
  homeUrl: '',
  blockHourUrl: 'blockHour',
  getLoanEndpoint:"#{{getLoanEndpoint}}#",
  endpointPayment: "#{{paymentEndpoint}}#",
  getPaymentReference: "#{{paymentLinkEndpoint}}#",
  getPaymentReferenceMSV: "#{{paymentMSVLinkEndpoint}}#",
  sigIntEndpoint: "#{{sigIntEndpoint}}#",
  enableRecaptcha: "#{{enableRecaptcha}}#",
  siteKeyCaptcha: "#{{recaptchaKey}}#",
  wompiKey: "#{{wompiKey}}#",
  redirectUrlWompi: "#{{urlRedirect}}#",
  hourBlockStart: "#{{hourBlockStart}}#",
  noindex: true,
  // GTM Configuration
  gtmId: 'GTM-52BS9HC',
  gtmIds: ['GTM-52BS9HC', 'GTM-PCQRWGZD', 'GTM-NPHDSDHL'],
  gtmAuth: '#{{gtmAuth}}#',
  gtmPreview: 'env-1'
};